import getCookie from '@/utils/getCookie'

const hashToken = (token) => {
  let hash = 5381
  for (let i = 0; i < token.length; i++) {
    hash = ((hash << 5) + hash) + token.charCodeAt(i)
    hash = hash & hash
  }
  return (hash >>> 0).toString(16)
}

const getTokenFingerprint = () => {
  const token = getCookie('cgToken')
  if (!token) return null
  return hashToken(token)
}

export default getTokenFingerprint
